export default __webpack_public_path__ + "static/top-6bc21013cca0dc757c742ed2bb53b00e.jpg";